import { render, staticRenderFns } from "./koruMapping.vue?vue&type=template&id=1c59effb&"
import script from "./koruMapping.vue?vue&type=script&lang=js&"
export * from "./koruMapping.vue?vue&type=script&lang=js&"
import style0 from "./koruMapping.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports